export default __webpack_public_path__ + "static/media/visa-logo.a079dd58.png";